import { getRestApiBearerToken } from './apiToken';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.stepflow.dev';

/** Canonical Agentic Network event (v1 envelope + legacy ``type`` for STATUS_UPDATE). */
export type AgenticNetworkEventEnvelope = Record<string, unknown> & {
  v?: number;
  eventId?: string;
  eventType?: string;
  networkId?: string;
  timestamp?: string;
};

export async function fetchNetworkChannelEvents(
  networkId: string,
  opts?: { limit?: number; cursor?: string; poolId?: string },
): Promise<{ events: AgenticNetworkEventEnvelope[]; nextCursor: string | null }> {
  const token = getRestApiBearerToken();
  if (!token) {
    throw new Error('Not authenticated');
  }
  const params = new URLSearchParams();
  if (opts?.limit != null) params.set('limit', String(opts.limit));
  if (opts?.cursor) params.set('cursor', opts.cursor);
  if (opts?.poolId) params.set('poolId', opts.poolId);
  const q = params.toString();
  const url = `${API_BASE_URL.replace(/\/$/, '')}/networks/${encodeURIComponent(networkId)}/channel-events${q ? `?${q}` : ''}`;
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || `HTTP ${res.status}`);
  }
  const data = (await res.json()) as { events?: AgenticNetworkEventEnvelope[]; nextCursor?: string | null };
  return {
    events: Array.isArray(data.events) ? data.events : [],
    nextCursor: data.nextCursor ?? null,
  };
}
